// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.language-selector {
  display: flex;
  gap: 10px;
  align-items: center;
}

.flag-icon {
  width: 30px;
  height: 20px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.flag-icon:hover {
  transform: scale(1.1);
}

.flag-icon.selected {
  border: 2px solid #007bff;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/LanguageSelector.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":[".language-selector {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.flag-icon {\n  width: 30px;\n  height: 20px;\n  cursor: pointer;\n  transition: transform 0.2s ease;\n}\n\n.flag-icon:hover {\n  transform: scale(1.1);\n}\n\n.flag-icon.selected {\n  border: 2px solid #007bff;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
